import { omit } from 'lodash';
import create from 'zustand';
import { ModalConfig } from './types';

type Store = {
  modals: Record<string, ModalConfig>;
  openModal: (config: ModalConfig) => void;
  closeModal: (id: string) => void;
};

const globalModalsStore = create<Store>((set) => ({
  modals: {},
  openModal: (config) => {
    set((state) => ({ modals: { ...state.modals, [config.id]: config } }));
  },
  closeModal: (id) => {
    set((state) => ({ modals: omit(state.modals, id) }));
  },
}));

type Controller = Pick<Store, 'openModal' | 'closeModal'> & {
  useModals: () => Store['modals'];
};

const globalModalsController: Controller = {
  useModals: () => globalModalsStore().modals,
  openModal: (config) => {
    globalModalsStore.getState().openModal(config);
  },
  closeModal: (id) => {
    globalModalsStore.getState().closeModal(id);
  },
};

export default globalModalsController;
